import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PanelLoaderPayload } from '@ispm/layout/classes/panel-loader-payload.abstract';
import { PanelsService } from '@ispm/layout/services/panels.service';
import { CurationPathwayTreeViewerComponent } from '../curation-pathway-tree-viewer/curation-pathway-tree-viewer.component';


@Injectable()
export class TreeViewPanelService {

  static readonly BpmnTreeViewlPanelName = 'bpmnTreeViewPanel';

  constructor(private panelService: PanelsService) {
  }

  public openTreeViewPanel(config, data, approveCallback: (...args) => void): Observable<any> {
    return this.openPanel(CurationPathwayTreeViewerComponent, config, data, approveCallback);
  }

  public closePanel(): Observable<any> {
    this.panelService.hideLayout(TreeViewPanelService.BpmnTreeViewlPanelName);
    return Observable.empty();
  }

  private openPanel(component: any, config, data, approveCallback: (...args) => void): Observable<any> {
    const payload = PanelLoaderPayload.builder()
      .setTitle(config.label)
      .setPayload({data: data, config: config, classes: '', shifted: true})
      .setApproveCallback(approveCallback);
    return this.panelService.showLayout(component, payload, TreeViewPanelService.BpmnTreeViewlPanelName);
  }
}
